import moment from "moment";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ModalLoading from "../components/ModalLoading";
import parse from "html-react-parser";
import { getDataAxios } from "../utils/Utils";

export default function InboxFragment() {
   const [dataNotification, setDataNotification] = useState([]);
   const [user] = useState(JSON.parse(localStorage.getItem("dompet_user")));
   const dataOutlet = JSON.parse(localStorage.getItem("dompet_detail_outlet"));

   const [showModalLoading, setShowModalLoading] = useState(false);
   const navigate = useNavigate();

   useEffect(() => {
      GetDataNotification();
   }, []);

   async function GetDataNotification() {
      setShowModalLoading(true);

      try {
         // get list notifications
         let res_notifications = await getDataAxios(
            `${process.env.REACT_APP_BASE_URL_API}/notif?channel_id=${dataOutlet.channel_id}&outlet_kartini_id=${dataOutlet.outlet_kartini_id}`
         );
         setDataNotification([...res_notifications.data.data]);
      } catch (error) {
         console.error(error);
      }

      setShowModalLoading(false);
   }

   return (
      <>
         <ModalLoading
            showModal={showModalLoading}
            setShowModal={setShowModalLoading}
         />
         <div className="-mx-2">
            <div className="text-lg font-semibold text-gray-900 uppercase pt-1.5 pb-2 px-4">
               Inbox
            </div>
            <div>
               <ul>
                  {dataNotification.map((notification, i) => (
                     <li
                        key={i}
                        className="border-b border-gray-200 last:border-0"
                     >
                        <div
                           className="block py-2 px-4 hover:bg-gray-50"
                           // to="#0"
                           onClick={() =>
                              navigate("/detail-notification", {
                                 state: notification,
                              })
                           }
                        >
                           <span className="block text-sm mb-2">
                              📣&nbsp;&nbsp;
                              <span className="font-semibold text-gray-700">
                                 {notification.title}
                              </span>
                              <p className="text-gray-600">
                                 {notification.content.length > 220
                                    ? parse(
                                         `${notification.content.substring(
                                            0,
                                            220
                                         )}...`
                                      )
                                    : notification.content}
                              </p>
                           </span>
                           <span className="block text-xs font-medium text-gray-400">
                              {moment(notification.created_at).format(
                                 "DD MMM YYYY"
                              )}
                           </span>
                        </div>
                     </li>
                  ))}
               </ul>
            </div>
         </div>
      </>
   );
}
